var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3BEBAA",
    fillRule: "evenodd",
    d: "m11.25 18.534l-6.3-6.048c-.53-.558-1.028-1.97-.298-2.654c.198-.186.53-.493.93-.865c1.033-.958 2.522-2.34 3.347-3.137c.771-.743 1.721-1.001 2.638-.174a77 77 0 0 1 2.212 2.088l-1.758 4.976l-1.672 1.561l1.705 1.67zm-4.325-7.572l3.473-3.228l1.654 1.622l-3.432 3.261z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02BCE4",
    fillRule: "evenodd",
    d: "m10.29 11.032l3.427 3.32l-2.51 2.379c-.303.302-.727 1.085 0 1.803s1.604.073 1.952-.34l5.94-5.732c.385-.447 1.081-1.763.156-2.677a117 117 0 0 0-2.671-2.532c-.438-.35-1.625-.742-2.873.492a173 173 0 0 1-3.42 3.287m3.484.001l1.712 1.677l1.698-1.589l-1.766-1.667z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01A5E2",
    d: "m13.778 11.028l-1.745 1.661l-1.744-1.66l1.744-1.655z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerp);
export default __webpack_public_path__ + "static/media/perp.166488eda011447dd4aa3bf960f9553a.svg";
export { ForwardRef as ReactComponent };